import {AfterViewInit, Component, OnInit} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef } from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {Subject} from 'rxjs';
import {ThietBi} from '../../../models/danhmuc/thietbi';
import {DangKyService} from '../../../service/vpp/service-dangky';
import {ThietBiService} from '../../../service/danhmuc/service-thietbi';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../global/commandutil';
import {Sessioncommand} from '../../../global/sessioncommand';
import {Phong} from '../../../models/danhmuc/phong';
import {PhongService} from '../../../service/danhmuc/service-phong';
import {DangKyHopService} from '../../../service/vpp/service-dangkyhop';
import {DangKyHop} from '../../../models/vpp/dangkyhop';
import {DomSanitizer} from '@angular/platform-browser';

;

@Component({
  templateUrl: './detail.component.html'

})
export class DetailDangKyPhongComponent implements OnInit, AfterViewInit {

  public language = language;
  public id: number=0;
  public dangKyHop: DangKyHop = new DangKyHop();
  public onClose: Subject<boolean>;
  constructor( public dangKyService: DangKyHopService,
               public _bsModalRef: BsModalRef,
               public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public edit(id: number) {

    this.dangKyService.getById(id).pipe(first())
      .subscribe(x => {
       this.dangKyHop = x;
      });
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

